import { useBuyCart } from "@/Hooks/BuyCart/BuyCart";
import type { MCart } from "@/Models/MCheckout/MCcart";
import type { Price } from "@/Type/Price";
import { formatMX } from "@/Utils/Fomat.price";
import React, { createContext, useCallback, useContext, useState } from "react";

type CartContextType = {
  AddCart: (
    IdSKU: string,
    TitleProduct: string,
    SoldByProduct: string,
    PriceProduct: Price,
    ImageProduct: string,
    LimitQuantity: number,
    Quantity?: Price,
    Country?: string,
    City?: string,
    ZipCode?: string,
    Cupon?: string
  ) => void;
  DeleteCart: (sku: string) => void;
  ViewCart: (sku: string) => void;
  taskCart: MCart[];
  ViewSubTotal: string;
  ViewCartQuantity: (sku: string, CSaleLimit: number) => boolean;
  UpdateCountCart: (IdSKU: string, quantity: Price) => void;
  SendBuyCartV2: (
    idSkus: string[],
    Country: string,
    City: string,
    ZipCode: number,
    Cupon: string
  ) => void;
  saveViewModal: (v: boolean, idSKU: string) => void;
  saveID: string;
};

const CheckoutContext = createContext<CartContextType | undefined>(undefined);

export const ContextCheckoutProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  //activamos la vista de modal.
  const [viewModal, setViewModal] = useState<boolean>(false);
  //pasamos el id del articulo.
  const [saveID, setsaveID] = useState<string>("");
  //llamamos al hooks al que se encarga de guardar los datos y removerlos del carrito.
  const {
    addCheckoutSKU,
    AddCartGo,
    DeleteCart,
    ViewCart,
    UpdateCountCart,
    SendBuyCartV2,
  } = useBuyCart();

  const taskCart = addCheckoutSKU ?? [];

  const ViewSubTotal = formatMX(
    addCheckoutSKU.reduce((a, b) => {
      const unitPrice = b.PriceProduct;
      return a + unitPrice * (b.Quantity ?? 1);
    }, 0)
  );

  const ViewCartQuantity = useCallback(
    (sku: string, CSaleLimit: number) => {
      const item = addCheckoutSKU.find((i) => i.IdSKU === sku);
      if (item && item.Quantity! >= CSaleLimit) return true;
      return false;
    },
    [addCheckoutSKU]
  );

  const AddCart = useCallback(
    (
      IdSKU: string,
      TitleProduct: string,
      SoldByProduct: string,
      PriceProduct: Price,
      ImageProduct: string,
      LimitQuantity: number
      //Quantity?: Price
    ) => {
      const exit = ViewCart(IdSKU);
      if(Number(exit) > 0) return;

      AddCartGo(
        IdSKU,
        TitleProduct,
        SoldByProduct,
        PriceProduct,
        ImageProduct,
        LimitQuantity
      );
    },
    []
  );

  const saveViewModal = useCallback((v: boolean, idSKU: string) => {
    setViewModal(v);
    setsaveID(idSKU);
  }, []);

  return (
    <CheckoutContext.Provider
      value={{
        AddCart,
        DeleteCart,
        ViewCart,
        taskCart,
        ViewSubTotal,
        ViewCartQuantity,
        UpdateCountCart,
        SendBuyCartV2,
        saveViewModal,
        saveID,
      }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useContextCheckoutData = () => {
  const context = useContext(CheckoutContext);
  if (!context)
    throw new Error(
      "useContextHomeData must be used within a CheckoutContextProvider"
    );
  return context;
};
